import { defineAsyncComponent } from 'vue'
export default {
  customer: defineAsyncComponent(() => import("/home/yannick/Documents/ensolarado/clients/refueat/refueat-app/layouts/customer.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/home/yannick/Documents/ensolarado/clients/refueat/refueat-app/layouts/default.vue").then(m => m.default || m))
}